export const translation_13_1_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `꾸러미와 결과`,
      typography_1: `특정한 상황을 마주할 때, 우리는 여러 가지 경험을 동시에 겪게 됩니다. 이른바 '경험 꾸러미'라고 부르는 이것은 생각, 감정, 신체 반응, 그리고 행동으로 이루어져 있습니다.`,
      typography_2: `지난 시간까지는 꾸러미에서 생각과 감정, 신체 반응을 관찰했습니다. 이제 이 꾸러미의 마지막 요소인 '행동'을 분리해 내는 연습을 해보겠습니다.`,

      typography_3: `결과로서의 행동`,
      typography_4: `행동은 꾸러미의 마지막 요소로서 '결과'를 담당합니다. 우린 생각에 반응하여 감정과 신체 반응을 느끼고, 결국에 어떤 충동을 느끼며 행동하게 됩니다.`,
      typography_5: `즉, 우리가 분리해낼 행동은 부정적인 경험의 결과로서 나도 모르게 튀어나온 즉각적이고 본능적인 행동을 말합니다. 예를 들면, 불안함에 손톱을 물어뜯거나 분노를 느끼며 타인에게 언성을 높인 것 등이 여기에 속합니다.`,
      typography_6: `갑작스러운 스트레스를 마주할 때 주로 어떤 행동을 보이시나요? 자신에게 가장 가까운 것을 골라보세요.`,
      typography_7: `심리적 괴로움을 받는 상황에서 사람의 마음은 본능적으로 얼어붙거나(정지), 피하거나(도피), 맞서 싸우려는(투쟁) 방향으로 작동합니다. 그러므로 이 '정지, 도피, 투쟁'의 관점에서 접근해 보면, 행동과 충동을 알아차리기가 한결 수월해집니다.`,
      typography_8: `물론 앞으로 행동을 분리해낼 때, 매번 이 세 가지로 범주로 명확히 구분하진 않을 겁니다. 하나의 행동에는 이 셋이 복합적으로 포함될 수 있기 때문입니다.`,
      typography_9: `예를 들면, "계속 그런 일이 발생할까봐 걱정했다"라는 행동은 순간 하던일을 멈추고(정지) 실질적인 문제 해결을 미루며(도피), 불안감을 없애려고(투쟁)하는 것이기도 합니다.`,
      typography_10: `그러니 명확한 구분과 1:1 대응을 신경쓰기보다는 '결과로서의 행동'은 주로 '정지, 도피, 투쟁'하는 모습을 띤다는 정도로 이해하는 것이 좋습니다. 이처럼 생존을 위해 튀어나오는 본능의 관점에서 바라보면, 꾸러미 속에서 결과로서 나타난 행동을 쉽게 찾아 분리해낼 수 있을 것입니다.`,
      typography_11: `우리가 분리해내는 행동은 의도적으로 노력한 대처 행동이 아닙니다. 마음을 진정시키기 위해 명상을 하거나 안정을 취하려 노력하는 등의 능동적인 대처는 꾸러미 속 행동이 아님을 주의해주세요.`,
      typography_12: `다음 중 꾸러미에서 분리해낸 '행동'으로 적절한 것은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_13: `정답은 C입니다. 심호흡이나 명상은 불안을 통제하기 위해 스스로 선택한 '능동적 대처'입니다. 여기서 관찰하고 기록해야 할 것은 부정적인 상황의 결과로 나타난 행동입니다.`,

      typography_14: `신체 반응과 행동 구분하기`,
      typography_15: `행동을 분리할 때 신체 반응과 혼동하는 경우가 흔히 발생하곤 합니다. 신체 반응은 심장이 뛰거나 식은땀이 나는 등 몸에서 느껴지는 '감각'입니다. 반면 행동은 겉으로 드러나는 '구체적인 움직임이나 물리적인 변화'를 의미합니다.`,
      typography_16: `다음 중 신체 반응이 섞이지 않고 오직 '행동'만 올바르게 적힌 것은 무엇일까요?`,
      typography_17: `정답은 C입니다. A에는 '가슴이 답답하고 두근거려서'가, B에는 '얼굴이 붉어지고 손이 떨려서'라는 신체 반응이 섞여 있습니다. C만이 외부로 명확하게 드러나는 행동입니다.`,
      typography_18: `그렇다면 "가슴이 답답하고 두근거려서 침대에 누워버림"을 올바른 '행동' 기록으로 가장 잘 수정한 것은 무엇일까요?`,
      typography_19: `정답은 B입니다. '가슴이 답답하고 두근거림'은 신체 반응입니다. 따라서 순수한 물리적 행동인 '침대에 누워버림'만 적어내는 것이 올바른 분리 연습입니다.`,

      typography_20: `내면의 충동 관찰`,
      typography_21: `때로는 마음속에 거대한 폭풍이 일었지만 겉으로는 아무런 행동도 하지 않을 때가 있습니다. 이럴 때는 행동이 없었다고 넘어가기보다는 그 순간 강렬하게 일어났던 '충동'을 알아차릴 수 있어야 합니다. 행동으로 옮기지는 않았으나 내면에서 솟구쳤던 강한 투쟁이나 도피의 욕구 역시 훌륭한 관찰 대상이 됩니다.`,
      typography_22: `당장이라도 자리를 박차고 나가고 싶었다거나 누군가에게 소리를 지르고 싶었던 마음이 바로 '충동'에 해당합니다. 이러한 충동을 찾아내어 문자로 적어보는 것만으로도, 마음속에서 어떤 일들이 벌어지고 있는지 알아차리는 데 큰 도움이 됩니다. 내면에서 꿈틀거렸던 날것의 충동을 온전히 인정하고 솔직하게 마주해 보세요.`,

      typography_23: `직접 해보기`,
      typography_24: `지금까지 경험 꾸러미에서 '행동'을 분리해내는 법을 배웠습니다. 앞서 분리해낸 생각, 감정, 신체 반응의 결과로서 나타난 본능적인 행동을 잘 알아차려보시기 바랍니다. 특별히 실제로 행한 행동이 없다면, 어떻게 하고 싶었다라는 충동을 알아차려도 좋습니다.`,
      typography_25: `이제 직접 실습해 볼 차례입니다. 앞서 연습을 위해 떠올렸던 그 부정적 순간으로 다시 주의를 돌려보세요.`,
      typography_26: `그 순간에 떠오른 경험 꾸러미를 해체해보겠습니다. 먼저 생각입니다. 그 순간에 어떤 생각이 튀어올랐는지 다시 알아차려 적어봅니다.`,
      typography_27: `그 생각에 반응해 마음에 어떤 감정이 일었는지 천천히 떠올려 적어보세요.`,
      typography_28: `그 당시 몸에서 어떤 감각이 느껴졌는지 천천히 떠올려 적어보세요.`,
      typography_29: `이제 마지막으로 그 반응의 결과로 나타났던 행동이나 내면의 충동을 적어봅니다.`,
      typography_30: `좋습니다. 코치 선생님이 확인 후 피드백 남겨주실 겁니다.`,
    },
  },
};
